<script setup lang="ts">
import MButton from ".";
</script>
<template>
  <div class="flex flex-col gap-3">
    <div>
      <p>Button</p>
      <div class="flex gap-3">
        <m-button label="Button" />
        <m-button label="Secondary" color="secondary" />
        <m-button label="Danger" color="danger" />
        <m-button label="Disabled" disabled />
      </div>
    </div>
    <div>
      <p>Focus</p>
      <div class="flex gap-3">
        <m-button label="Button" class="focus-component" />
        <m-button label="Secondary" class="focus-component" color="secondary" />
        <m-button label="Danger" class="focus-component" color="danger" />
        <m-button label="Disabled" class="focus-component" disabled />
      </div>
    </div>

    <div>
      <p>Hover</p>
      <div class="flex gap-3">
        <m-button label="Button" class="hover-component" />
        <m-button label="Secondary" class="hover-component" color="secondary" />
        <m-button label="Danger" class="hover-component" color="danger" />
        <m-button label="Disabled" class="hover-component" disabled />
      </div>
    </div>

    <div>
      <p>Ghost Button</p>
      <div class="flex gap-3">
        <m-button ghost label="Button" />
        <m-button ghost label="Secondary" color="secondary" />
        <m-button ghost label="Danger" color="danger" />
        <m-button ghost label="Disabled" disabled />
      </div>
    </div>
    <div>
      <p>Focus</p>
      <div class="flex gap-3">
        <m-button ghost label="Button" class="focus-component" />
        <m-button ghost label="Secondary" class="focus-component" color="secondary" />
        <m-button ghost label="Danger" class="focus-component" color="danger" />
        <m-button ghost label="Disabled" class="focus-component" disabled />
      </div>
    </div>

    <div>
      <p>Hover</p>
      <div class="flex gap-3">
        <m-button ghost label="Button" class="hover-component" />
        <m-button ghost label="Secondary" class="hover-component" color="secondary" />
        <m-button ghost label="Danger" class="hover-component" color="danger" />
        <m-button ghost label="Disabled" class="hover-component" disabled />
      </div>
    </div>

    <p>Using to property</p>
    <div>
      <p>Button</p>
      <div class="flex gap-3">
        <m-button to="#" label="Button" />
        <m-button to="#" label="Secondary" color="secondary" />
        <m-button to="#" label="Danger" color="danger" />
        <m-button to="#" label="Disabled" disabled />
      </div>
    </div>
    <div>
      <p>Focus</p>
      <div class="flex gap-3">
        <m-button to="#" label="Button" class="focus-component" />
        <m-button to="#" label="Secondary" class="focus-component" color="secondary" />
        <m-button to="#" label="Danger" class="focus-component" color="danger" />
        <m-button to="#" label="Disabled" class="focus-component" disabled />
      </div>
    </div>

    <div>
      <p>Hover</p>
      <div class="flex gap-3">
        <m-button to="#" label="Button" class="hover-component" />
        <m-button to="#" label="Secondary" class="hover-component" color="secondary" />
        <m-button to="#" label="Danger" class="hover-component" color="danger" />
        <m-button to="#" label="Disabled" class="hover-component" disabled />
      </div>
    </div>

    <div>
      <p>Ghost Button</p>
      <div class="flex gap-3">
        <m-button to="#" ghost label="Button" />
        <m-button to="#" ghost label="Secondary" color="secondary" />
        <m-button to="#" ghost label="Danger" color="danger" />
        <m-button to="#" ghost label="Disabled" disabled />

        <m-button ghost icon="fa-solid fa-xmark" />
        <m-button ghost icon="fa-solid fa-xmark" disabled />
      </div>
    </div>
    <div>
      <p>Focus</p>
      <div class="flex gap-3">
        <m-button to="#" ghost label="Button" class="focus-component" />
        <m-button to="#" ghost label="Secondary" class="focus-component" color="secondary" />
        <m-button to="#" ghost label="Danger" class="focus-component" color="danger" />
        <m-button to="#" ghost label="Disabled" class="focus-component" disabled />

        <m-button ghost icon="fa-solid fa-xmark" class="focus-component" />
        <m-button ghost icon="fa-solid fa-xmark" class="focus-component" disabled />
      </div>
    </div>

    <div>
      <p>Hover</p>
      <div class="flex gap-3">
        <m-button to="#" ghost label="Button" class="hover-component" />
        <m-button to="#" ghost label="Secondary" class="hover-component" color="secondary" />
        <m-button to="#" ghost label="Danger" class="hover-component" color="danger" />
        <m-button to="#" ghost label="Disabled" class="hover-component" disabled />

        <m-button ghost icon="fa-solid fa-xmark" class="hover-component" />
        <m-button ghost icon="fa-solid fa-xmark" class="hover-component" disabled />
      </div>
    </div>
    <div class="bg-grey">
      <p>Background</p>

      <div class="flex gap-3">
        <m-button to="#" label="Button" class="hover-component" />
        <m-button to="#" label="Secondary" class="hover-component" color="secondary" />
        <m-button to="#" label="Danger" class="hover-component" color="danger" />
        <m-button to="#" label="Disabled" class="hover-component" disabled />

        <m-button icon="fa-solid fa-xmark" class="hover-component" />
        <m-button icon="fa-solid fa-xmark" class="hover-component" disabled />
      </div>
    </div>
    <div class="bg-grey">
      <p>Background Ghost</p>

      <div class="flex gap-3">
        <m-button to="#" ghost label="Button" class="hover-component" />
        <m-button to="#" ghost label="Secondary" class="hover-component" color="secondary" />
        <m-button to="#" ghost label="Danger" class="hover-component" color="danger" />
        <m-button to="#" ghost label="Disabled" class="hover-component" disabled />

        <m-button ghost icon="fa-solid fa-xmark" class="hover-component" />
        <m-button ghost icon="fa-solid fa-xmark" class="hover-component" disabled />
      </div>
    </div>
  </div>
</template>
